import Emitter from 'tiny-emitter'

const emitter = new Emitter()

// Raw emitter, shared with the $bus plugin below. Exported so plain-JS modules
// (e.g. plugins/http/interceptors.js) that have no Vue `this`/`$bus` can still
// emit/listen on the same bus instance the components use.
export { emitter as bus }

export default {
  install: function (app) {
    app.config.globalProperties.$bus = {
      $on: (...args) => emitter.on(...args),
      $once:  (...args) => emitter.once(...args),
      $off: (...args) => emitter.off(...args),
      $emit: (...args) => emitter.emit(...args),
    }
    
  }
}